/**
 * Eine Enumeration mit den unterschiedlichen Types von Views.
 */
export enum ViewType {

	/** Normale View */
	DEFAULT,

	/** View zum Hinzufügen von Daten */
	HINZUFUEGEN,

	/** View, welcher Gruppenprozesse bereitstellt */
	GRUPPENPROZESSE,

	/** View, welcher die Schnelleingabe bereitstellt */
	NEU

}
